<template>
    <rkm-layout-body title="Lista de fórmulas">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'exame-laboratorial-formula-exame-create' })"
                color="primary"
                authorize="store-exame-laboratorial-formula-exame"
            >
                Cadastrar fórmula
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/exame-laboratorial/formula-exame/List'

export default {
    components: { List },
}
</script>